/* eslint-disable */
import React, { useContext } from 'react';
import { Filters, Data } from '../contexts';
import { cardonator } from '../HOCs';
import { parseMoney } from "../../utils";

const PeopleCustomersTable = (props) => {
  const { filters } = useContext(Filters);
  const { ytd_months } = useContext(Data);
  let finalFilters = props.tabFilters || filters;
  let compareWith = finalFilters.compare_with
  let numberCompare;
  if ((finalFilters && compareWith === 'Default:YOY') || (compareWith && compareWith.includes("Forecast"))) {
    numberCompare = 'n = 1'
  } else {
    if (finalFilters.display_columns_by === 'Years' && finalFilters.report_period !== 'Year to Date') {
      numberCompare = `n = ${props.aggregateData?.annual_n?.[props.year] ?? 0}`;
    } else {
      numberCompare = `n = ${props.aggregateData?.monthly_avg_n?.[props.year] ?? 0}`;
    }
  }
  let backgroundColor = '';
  let cellClass = '';
  let commonSizeValCellClass = 'common-size-cell';
  let tableClasses;

  if (props.page === 'people') {
    backgroundColor = '#8ADFFE';
    cellClass = 'people-table-cell';
    commonSizeValCellClass += ' people-table-cell';
    tableClasses = "people-report-table";
  } else {
    backgroundColor = '#CDA5DE';
    cellClass = 'customers-table-cell';
    commonSizeValCellClass += ' customers-table-cell';
    tableClasses = "customers-report-table";
  }

  const buildRowsMonths = () => {
    const endMonthOfSelectedYear = finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year ? Number(finalFilters.date_through_monthly_month) : 12;

    return props.rows.map((row, i) => {
      let rowChecked = row.checked && props.reportMetrics['editMetrics'] ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''
      let emptyCellVal = row.emptyRow ? '' : '-'
      return (
        <tr key={Math.random(80) + 'buildRowMonths'} id={`${props.chart}-report-row-${i}`} onClick={() => props.reportMetrics['editMetrics'] ? props.handleSelectAndLayout(props.page, 'financial_detail', row.key) : null}>
          {!props.pdf ? <td>{rowChecked}</td> : null}
          <td className="table-copy">{row.copy}</td>
          {Object.keys(props.monthsObj).map((month, ii) => {
            if (Object.keys(row).length > 1) {
              return (
                <td key={Math.random(80)}>
                  {Number(month) <= endMonthOfSelectedYear && row[ii + 1] ? parseMoney(row[ii + 1]) : emptyCellVal}
                </td>
              )
            } else {
              <td key={Math.random(80)}></td>
            }
          })}
          <td>
            {row['youCommonSize'] ? row['youCommonSize'].toFixed(2) + '%' : emptyCellVal}
          </td>
          {
            finalFilters.compare_with === 'Default:None' || finalFilters.compare_with === 'None'
              ? null
              : <React.Fragment key={Math.random(80)}>
                <td>{row['arrow']}</td>
                <td>
                  {row['compareCommonSize'] ? row['compareCommonSize'].toFixed(2) + '%' : emptyCellVal}
                </td>
              </React.Fragment>
          }
          <td></td>
        </tr>
      )
    })
  }

  const buildRowsYears = () => {
    if (finalFilters.report_period !== 'Year to Date') {
      return props.rows.map((row, i) => {
        let rowChecked = row.checked && props.reportMetrics['editMetrics'] ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''
        let emptyCellVal = row.emptyRow ? '' : '-'
        return (
          <tr key={Math.random(80) + 'buildRowYears'} id={`${props.chart}-report-row-${i}`} onClick={() => props.reportMetrics['editMetrics'] ? props.handleSelectAndLayout(props.page, 'financial_detail', row.key) : null}>
            {!props.pdf ? <td>{rowChecked}</td> : null}
            <td className="table-copy">{row.copy}</td>
            {props.yearRange.map((year, i) => {
              let backgroundStyle = {}
              let commonSizeValCellClass = 'common-size-cell ';
              let valueCellClass = '';

              if (i % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
                backgroundStyle['backgroundColor'] = backgroundColor;
                commonSizeValCellClass += cellClass;
                valueCellClass = cellClass;
              }

              if (Object.keys(row).length > 2) {
                return (
                  <React.Fragment key={Math.random(80)}>
                    <td className={valueCellClass} style={backgroundStyle}>
                      {row[year] ? parseMoney(row[year]) : emptyCellVal}
                    </td>
                    <td className={valueCellClass} style={backgroundStyle}>
                      {row[year + 'youCommonSize'] ? row[year + 'youCommonSize'].toFixed(2) + '%' : emptyCellVal}
                    </td>
                    <td className={commonSizeValCellClass} style={backgroundStyle}>{row[year + 'arrow']}</td>
                    <td className={valueCellClass} style={backgroundStyle}>
                      {row[year + 'compareCommonSize'] ? row[year + 'compareCommonSize'].toFixed(2) + '%' : emptyCellVal}
                    </td>
                    <td></td>
                  </React.Fragment>
                )
              } else {
                return (
                  <React.Fragment key={Math.random(80)}>
                    <td className={valueCellClass} style={backgroundStyle}></td>
                    <td className={valueCellClass} style={backgroundStyle}></td>
                    <td className={commonSizeValCellClass} style={backgroundStyle}></td>
                    <td className={valueCellClass} style={backgroundStyle}></td>
                    <td></td>
                  </React.Fragment>
                )
              }
            })}
          </tr>
        )
      })
    } else {
      return props.rows.map((row, i) => {
        let rowChecked = row.checked && props.reportMetrics['editMetrics'] ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''
        let emptyCellVal = row.emptyRow ? '' : '-'
        return (
          <tr key={Math.random(80) + 'buildRowsYTD'} id={`${props.chart}-report-row-${i}`} onClick={() => props.reportMetrics['editMetrics'] ? props.handleSelectAndLayout(props.page, 'financial_detail', row.key) : null}>
            {!props.pdf ? <td>{rowChecked}</td> : null}
            <td className="table-copy">{row.copy}</td>
            {[props.year - 1, props.year].map((year, i) => {
              let arrowCellClass = 'common-size-arrow';
              let backgroundStyle = {}
              let commonSizeValCellClass = 'common-size-cell';
              let valueCellClass = '';
              if (i % 2 === 0) {
                backgroundStyle['backgroundColor'] = backgroundColor;
                valueCellClass = cellClass
              }
              return (
                <React.Fragment key={Math.random(80)}>
                  <td className={valueCellClass} style={backgroundStyle}>{row[year] ? parseMoney(row[year]) : emptyCellVal}</td>
                  <td className={valueCellClass} style={backgroundStyle}>{row[year + 'youCommonSize'] ? row[year + 'youCommonSize'].toFixed(2) + '%' : emptyCellVal}</td>
                  {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className={valueCellClass} style={backgroundStyle}>{row[year + 'compareCommonSize'] ? row[year + 'compareCommonSize'].toFixed(2) + '%' : emptyCellVal}</td>}
                  <td></td>
                </React.Fragment>
              )
            })}
            <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}>{parseMoney(row[props.year - 1] - row[props.year]) ? parseMoney(row[props.year - 1] - row[props.year]) : emptyCellVal}</td>
          </tr>
        )
      })
    }
  }

  const renderYearHeaderColumns = (displayColumnsBy, reportPeriod) => {
    const currentYear = new Date().getFullYear();
    let monthsHeaders;
    let formatedYearsRow = [];
    let youPeersRow = [];

    if (displayColumnsBy === 'Years') {
      if (reportPeriod !== 'Year to Date') {
        props.yearRange.forEach((y, i) => {
          const year = Number(y);
          let arrowCellClass = 'common-size-arrow ';
          let backgroundStyle = {}
          let commonSizeValCellClass = 'common-size-cell ';
          let youDate, compareDate = '';

          if (year === currentYear) {
            youDate = props.companyYTDDate;
            compareDate = props.aggregateYTDDate;
          } else {
            youDate = props.calendarYearEnd ? `${props.fiscalYearEnd}/${year}` : props.fiscalYearEnd ? `${props.fiscalYearEnd}/${year + 1}` : `12/31/${year}`;
            compareDate = `12/31/${year}`;
          }

          if (i % 2 === 0 && (!props.pdf || (props.pdf && props.yearRange.length !== 2))) {
            arrowCellClass += cellClass;
            backgroundStyle['backgroundColor'] = backgroundColor
            commonSizeValCellClass += cellClass;
          }

          youPeersRow.push(
            <React.Fragment key={Math.random(i) + 'tcpc-year-headers'}>
              <td colSpan="2" className={commonSizeValCellClass} style={backgroundStyle}>You</td>
              <td className={arrowCellClass} style={backgroundStyle}></td>
              <td className={commonSizeValCellClass} style={backgroundStyle}>Peers</td>
              <td className='space-cell'></td>
            </React.Fragment>
          )

          formatedYearsRow.push(
            <React.Fragment key={Math.random(i) + 'tcpc-year-headers'}>
              <td colSpan="2" className={commonSizeValCellClass} style={backgroundStyle}>{youDate}</td>
              <td className={arrowCellClass} style={backgroundStyle}></td>
              <td className={commonSizeValCellClass} style={backgroundStyle}>{compareDate}</td>
              <td className='space-cell'></td>
            </React.Fragment>
          )
        })

        return (
          <thead>
            <tr key={Math.random(20)}>
              {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.reportMetrics['editMetrics'] ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
              <td></td>
              {youPeersRow}
            </tr>
            <tr key={Math.random(20)}>
              {!props.pdf ? <td></td> : null}
              <td></td>
              {formatedYearsRow}
              {props.yearRange.length === 2 ? <td></td> : null}
            </tr>
          </thead>
        )

      } else {
        // YTD Headers
        return (
          <thead>
            <tr>
              {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.reportMetrics['editMetrics'] ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
              <td></td>
              <td className={cellClass} style={{ 'backgroundColor': backgroundColor }}>{`YTD ${props.clientFirstYearMonth}/${props.year - 1}`}</td>
              <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}> You</td>
              {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}>Peers</td>}
              <td></td>
              <td>{`YTD ${props.clientSecondYearMonth}/${props.year}`}</td>
              <td className='common-size-cell'>You</td>
              {compareWith === 'Default:None' || compareWith === 'None' ? null : <td className='common-size-cell'>Peers</td>}
              <td></td>
              <td className={`common-size-cell ${cellClass}`} style={{ 'backgroundColor': backgroundColor }}>Δ Delta</td>
            </tr>
          </thead>
        )
      }
    } else {
      let youTitle = finalFilters.report_period === 'Trailing 12' ? `You T12 ${props.year}` : 'You YTD'
      let YOYyearDisplay = props.calendarYearEnd ? props.year - 1 : props.year
      let compareTitle = null
      if (compareWith && compareWith.includes('Forecast') && finalFilters.report_period !== 'Trailing 12') {
        compareTitle = props.monthlyCompareWithTitle
      } else if (compareWith === 'Default:Peers' && finalFilters.report_period !== 'Trailing 12') {
        compareTitle = 'Peers Avg'
      } else if (compareWith === 'Default:YOY' && finalFilters.report_period !== 'Trailing 12') {
        compareTitle = `YOY ${YOYyearDisplay}`
      } else if (finalFilters.report_period === 'Trailing 12' && compareWith !== 'Default:None') {
        compareTitle = `T12 ${props.year - 1}`
      }
      // Months Headers
      monthsHeaders = Object.values(props.monthsObj).map(month => {
        return <td key={Math.random(80) + 'tcpc-months-headers'}>{month}</td>
      })
      monthsHeaders.push(
        <React.Fragment key={Math.random(80)}>
          <td>{youTitle}</td>
          {
            compareWith === 'Default:None' || compareWith === 'None'
              ? null
              : (
                <React.Fragment key={Math.random(80)}>
                  <td></td>
                  <td>{compareTitle}</td>
                </React.Fragment>
              )
          }
        </React.Fragment>
      )

      return (
        <thead>
          <tr key={Math.random(20)}>
            {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.reportMetrics['editMetrics'] ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
            <td></td>
            {monthsHeaders}
          </tr>
        </thead>
      )
    }
  }

  const buildTable = (displayColumnsBy, reportPeriod) => {
    if (props.pdf) {
      let annualView2Yrs = displayColumnsBy === 'Years' && reportPeriod !== 'Year to Date'
      let pageViewClass = annualView2Yrs && props.yearRange.length === 2 ? 'portrait-view' : 'landscape-view'
      let printViewClass = annualView2Yrs && props.yearRange.length === 2 ? 'money-pdf-portrait' : 'report-pdf-landscape'
      let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName
      let yearRangeText = annualView2Yrs ? `${props.yearRange[0]} - ${props.yearRange[props.yearRange.length - 1]}` : finalFilters.year
      let pageTitle = props.page.charAt(0).toUpperCase() + props.page.slice(1);

      const tabName = (props.tabName || pageTitle || '').trim().toLowerCase();
      const title = (pageTitle || '').trim().toLowerCase();
      let reportTitle = tabName.includes(title) ? props.tabName : `${props.tabName}, ${props.title} Financial Detail Report`;
      let naicsCode = finalFilters.code;
      let dataType = finalFilters.datatype;
      let revenueBand = finalFilters.revenue_band;
      let region = finalFilters.region;
      let numOfDocs = finalFilters.number_of_pros || 'All';
      let compare = finalFilters.compare_with;
      let filtersTitle;

      if (displayColumnsBy === 'Months' || reportPeriod === 'Year to Date') {
        const compareParts = finalFilters.compare_with.split(':');
        let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
        filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;
      } else {
        let compare = finalFilters.compare_with
        filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Compare with: ${compare}`;
      }

      return (
        <div className={pageViewClass}>
          <div className={printViewClass}>
            <div>
              {
                annualView2Yrs && props.yearRange.length === 2
                  ? (
                    <div>
                      <p className='report-annual-title'>{reportTitle}</p>
                      <p className='report-company-title'>{clientNames}</p>
                      <p className='report-year-range-title'>{yearRangeText}</p>
                      <p className='report-filters-title'>{filtersTitle}</p>
                    </div>
                  )
                  : <div>
                    <p className='report-annual-title'>{`${reportTitle}, ${clientNames}, ${yearRangeText}`}</p>
                    <p className='report-filters-title'>{filtersTitle}</p>
                  </div>
              }
              <div className='money-pdf-table-div'>
                <table style={{ whiteSpace: 'pre' }} className='money-pdf-table' >
                  {renderYearHeaderColumns(displayColumnsBy, reportPeriod)}
                  <tbody>
                    {displayColumnsBy === 'Years' ? buildRowsYears() : buildRowsMonths()}
                    <tr><td className='footer-cell'><i>{numberCompare}</i></td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
          </div>
        </div>
      )
    } else {
      return (
        <div className='people-customers-pdf'>
          <div className='money-report-container'>
            <table style={{ whiteSpace: 'pre' }} className={tableClasses} >
              {renderYearHeaderColumns(displayColumnsBy, reportPeriod)}
              <tbody>
                {displayColumnsBy === 'Years' ? buildRowsYears() : buildRowsMonths()}
              </tbody>
              <tfoot>
                <tr>
                  <td><i>{numberCompare}</i></td>
                </tr>
                {['Peers', 'NSCHBC', 'Default:Peers'].includes(compareWith) ? <tr><td colSpan='2' className='peer-disclaimer'>Peer data is updated monthly on or after the 16th.</td></tr> : null}
              </tfoot>
            </table>
          </div>
        </div>
      )
    }
  }

  return (buildTable(finalFilters.display_columns_by, finalFilters.report_period))
}

export default cardonator(PeopleCustomersTable);